<div class='previewModal'>
    <div class="modal-header">
        <h4 class="modal-title roboTitle" id="modal-basic-title">{{'profile.changePw' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
      <div class='row'>
        <div class='form-group col-8' style='margin-left: 10px'>
            <label class="roboSubTitle">{{'profile.oldPw' | translate}}</label>
            <input class="form-control" [type]="field1.type" [(ngModel)]="oldPw" >
            <span toggle="#password-field" class="bi field-icon toggle-password" (click)="changePwVisibility(1)"
            [ngClass]="{'bi-eye-slash-fill' : field1.hide, 'bi-eye-fill' : !field1.hide}"></span>

        </div>
      </div>

      <div class='row'>
        <div class='form-group col-8' style='margin-left: 10px'>
            <label   class="roboSubTitle">{{'profile.newPw' | translate}}</label>
            <input class="form-control" [type]="field2.type"  [(ngModel)]="newPw" >
            <span toggle="#password-field" class="bi field-icon toggle-password" (click)="changePwVisibility(2)"
            [ngClass]="{'bi-eye-slash-fill' : field2.hide, 'bi-eye-fill' : !field2.hide}"></span>

        </div>
      </div>

      <div class='row'>
        <div class='form-group col-8' style='margin-left: 10px'>
            <label   class="roboSubTitle">{{'profile.confirmNewPw' | translate}}</label>
            <input class="form-control" [type]="field3.type"  [(ngModel)]="confirmNewPw" >
            <span toggle="#password-field" class="bi field-icon toggle-password" (click)="changePwVisibility(3)"
            [ngClass]="{'bi-eye-slash-fill' : field3.hide, 'bi-eye-fill' : !field3.hide}"></span>

        </div>
      </div>
        
        
        
        
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
        <button type="button" class="btn btn-outline-dark" (click)="saveNewPw()">{{ 'general.confirm' | translate }}</button>
    </div>
    </div>